import axiosInstance from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'
import { METHOD_TYPES } from 'constants/index'

const SERVER = { server: microServices.SERVICE_URL_1 }

export const getMarketsService = (params) =>
  axiosInstance(METHOD_TYPES.get, '/prediction-market/markets', {}, { ...SERVER, params })

export const getMarketDetailService = (conditionId, interval = '1d') =>
  axiosInstance(METHOD_TYPES.get, `/prediction-market/markets/${conditionId}`, {}, { ...SERVER, params: { interval } })

export const getOrderbookService = (params) =>
  axiosInstance(METHOD_TYPES.get, '/prediction-market/orderbook', {}, { ...SERVER, params })

export const placeBetService = (data) =>
  axiosInstance(METHOD_TYPES.post, '/prediction-market/bets', data, SERVER)

export const cancelBetService = (betId) =>
  axiosInstance(METHOD_TYPES.post, `/prediction-market/bets/${betId}/cancel`, {}, SERVER)

export const getUserBetsService = (params) =>
  axiosInstance(METHOD_TYPES.get, '/prediction-market/bets', {}, { ...SERVER, params })
